import React from 'react';
import DateRangePicker from '@lib/components/DateTimePicker/DateRangePicker';
import { InputTypes } from '@lib/components/Input/enums';
import { ComponentProps, defaultProps } from '../types';

export default function DateRangePreview({ t }: ComponentProps) {
  return (
    <DateRangePicker
      {...defaultProps}
      label={t('select-date-range')}
      type={InputTypes.dateRange}
    />
  );
}
